import React, {useEffect} from "react";
import Auth0LogoutButton from "./Auth0LogoutButton";
import remarkableAILogo from 'components/images/logos/remarkable_dark_logo.svg'
import {CopyrightFooter, Loading} from "../common";
import {useAuth0} from "@auth0/auth0-react";
import ReactGA from 'react-ga';
import {GOOGLE_ANALYTICS_TRACKING_ID} from "_constants";
import {authService} from "_services";
import {Box} from "@mui/system";
import importedStyles from "../v3/views/CompanyOnboarding/Utils/styles";

function PromptMessage () {

  useEffect(() => {
    ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
    ReactGA.pageview(window.location.pathname);
  }, []);

  let message;
  const url = window.location.href.trim();
  const { isAuthenticated, logout } = useAuth0();

  switch (true) {
    case url.includes('contact-support'):
      if(isAuthenticated){
        authService.logoutWithRedirect('contact-support');
      }
      message = 'Contact support@beremarkable.ai to complete setup';
      break;
    case url.includes('verify-email'):
      if(isAuthenticated){
        authService.logoutWithRedirect('verify-email');
      }
      message = 'We have sent a message to your email inbox. Please click the link in your email to verify your email address';
      break;
    case url.includes('profile-success'):
      if(isAuthenticated){
        authService.logoutWithRedirect('profile-success');
      }
      message = 'Your profile has been created, login to continue';
      break;
    case url.includes('invalid-invite'):
      if(isAuthenticated){
        authService.logoutWithRedirect('invalid-invite');
      }
      message = 'This invite link is no longer valid. For assistance, please contact our support team at support@beremarkable.ai';
      break;
  }

  if(isAuthenticated){ // at this point, the user is still being logged out from Auth0
    return <Loading/>
  }

  return (
    <Box sx={styles.root}>
      <Box sx={styles.container}>
        <Box className="content-pane" sx={styles.contentPane}>
          <Box sx={styles.body} className="font-16">
            <Box sx={{textAlign: 'center'}}>
              <Box component={'img'} src={remarkableAILogo} alt="remarkable ai logo" className="tms-logoImg" sx={{margin: "0 auto", maxWidth: '180px'}}/>
            </Box>
            <Box sx={styles.textContainer}>
              {message}
            </Box>
            <Box sx={{minHeight: '30px'}}>
              <Box sx={styles.buttonContainer}>
                <Auth0LogoutButton label={'Back to login'}/>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={{position: 'relative', top: '200px'}}>
          <CopyrightFooter/>
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  root: {
    background: "#edede4",
    minHeight: 'calc(100vh)'
  },
  container: {
    ...importedStyles.container,
    width: '100%',
  },
  contentPane: {
    width: {xs: '400px', sm: '450px', md: '550px', lg: '550px'},
    margin: "0 auto",
    borderRadius: '15px',
    top: '150px'
  },
  body: {
    minHeight: '200px',
    padding: '45px 0'
  },
  textContainer: {
    width: '95%',
    minHeight: '30px',
    textAlign: 'center',
    margin: '50px auto',
    fontSize: '16px',
    fontFamily: 'FustatMedium'
  },
  buttonContainer: {
    width: "170px",
    margin: "0 auto"
  }
}

export default PromptMessage;
